<template>
    <i :class="classes" @click="$emit('click', $event)"/>
</template>

<script>
    export default {
        props: {
            name: {type: String},
        },

        computed: {
            classes() {
                let classes = ['mdi'];
                for (let icon of this.name.split(/\s/g)) {
                    classes.push(`mdi-${icon}`);
                }
                return classes;
            },
        },
    };
</script>